package pl.mothdigital.neuronowi.components.sections.specialist

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.common.utils.*
import pl.mothdigital.neuronowi.common.utils.fixPolishOrphans
import pl.mothdigital.neuronowi.components.text.*
import pl.mothdigital.neuronowi.theme.*

/**
 * Standard header section for specialist pages.
 * Displays specialist's name, academic titles/roles, and phone number.
 *
 * @param name Specialist's full name
 * @param titles Academic titles and roles
 * @param phoneNumber Contact phone number
 */
@Composable
fun SpecialistHeaderSection(
    name: String,
    titles: String,
    phoneNumber: String
) {
    Section(
        attrs = Modifier
            .fillMaxWidth()
            .standardSectionPadding()
            .lightGreenBackground()
            .toAttrs()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().margin { auto },
            verticalArrangement = Arrangement.spacedBy(1.cssRem)
        ) {
            AppH1 { Text(name.fixPolishOrphans()) }

            AppP(
                color = SiteTheme.green._800,
                modifier = Modifier.fontSize(1.25.cssRem)
            ) {
                Text(titles.fixPolishOrphans())
            }

            AppP(
                color = SiteTheme.green._800,
                modifier = Modifier.fontSize(1.25.cssRem).fontWeight(FontWeight.Bold)
            ) {
                Text(phoneNumber)
            }
        }
    }
}
